import React, { Component } from "react";
import L from 'leaflet'
import { GeoLocation } from 'geodesy-js';
import { Angle, Length } from 'unitsnet-js';
import 'leaflet-rotatedmarker'
// import geojsonEarthSeas5km from '../geojson/earth-seas-5km.geo.json';
import geojsonEarthSeas10m from '../geojson/earth-seas-10m.geo.json';
// import geojsonEarthSeas250m from '../geojson/earth-seas-25m.geo.json';

class AdminMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boatMarkersList: [],
            portMarkersList: {},
            POIMarkersList: {},
            clickListenerAdded: false,
            customMarkerOpen: false
        }
        this.changeCustomMarkerPosition = this.changeCustomMarkerPosition.bind(this);
        this.zoomEventHandler = this.zoomEventHandler.bind(this);
        this.portClickEventHandler = this.portClickEventHandler.bind(this);
        this.POIClickEventHandler = this.POIClickEventHandler.bind(this);
        this.displayPorts = this.displayPorts.bind(this);
        this.displayPOIs = this.displayPOIs.bind(this);

    }
    componentDidMount() {
        this.setState({
        }, () => {
            this.setMap();
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // If port list changed, update ports
        if (JSON.stringify(prevProps.ports) != JSON.stringify(this.props.ports)) {
            this.displayPorts();
        }
        // If POI list changed, update POIs
        if (JSON.stringify(prevProps.POIs) != JSON.stringify(this.props.POIs)) {
            this.displayPOIs();
        }
    }
    render() {

        const AdminMap = this.state.AdminMap;

        // Ajouter un listener au click sur la carte
        if (AdminMap != undefined && !this.state.clickListenerAdded) {
            this.setState({ clickListenerAdded: true })
            AdminMap.on('click', (e) => this.changeCustomMarkerPosition(e)
            )
        }

        // Déplacer la popup des coordonnées
        if (!this.state.customMarker) {
            if (this.state.customMarkerPosition) {
                this.setState({
                    customMarker: L.popup({ autoPan: false })
                        .setLatLng(this.state.customMarkerPosition)
                        .on('remove', (e) => this.setState({ customMarkerOpen: false }))
                });
            }
        }
        else {
            if (this.state.customMarkerOpen) {
                this.state.customMarker.setLatLng(this.state.customMarkerPosition)
                    .setContent(this.state.customMarkerPosition.lat + ', ' + this.state.customMarkerPosition.lng).openOn(AdminMap);
            }
        }

        const boats = this.props.boats;
        let boatMarkers = [];
        if (boats && boats.length > 0) {
            for (let i = 0; i < boats.length; i++) {
                const boat = boats[i];
                const latLng = L.latLng(boat.lat, boat.long);

                const boatLocation = new GeoLocation({
                    Latitude: Angle.FromDegrees(boat.lat),
                    Longitude: Angle.FromDegrees(boat.long),
                });

                const boatIcon = L.icon({
                    iconUrl: '../img/boat.svg',
                    iconSize: [25, 25],
                    iconAnchor: [12.5, 12.5]
                });



                const boatMarkersList = this.state.boatMarkersList;
                // If first time seeing boats, add and register a marker
                if (!boatMarkersList[boat._id]) {
                    boatMarkers[boat._id] = L.marker([0, 0], {
                        icon: boatIcon
                    });
                    boatMarkers[boat._id].addTo(AdminMap);
                    boatMarkers[boat._id].bindTooltip(boat.name);

                    boatMarkersList[boat._id] = boatMarkers[boat._id];


                    this.setState({ boatMarkersList: boatMarkersList })
                }
                // Se tthe boat position
                boatMarkersList[boat._id].setLatLng(latLng);
                boatMarkersList[boat._id].setRotationAngle(boat.bearing);


            }
        }

        return (
            <div id="AdminMap" >

            </div >
        );
    }
    setMap() {
        let layer = new L.tileLayer('https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png');

        this.setState({
            AdminMap: new L.Map("AdminMap", {
                center: new L.LatLng(36.4, 18.2),
                zoom: 4,
                zoomControl: false,
                // bounceAtZoomLimits: false,
                zoomSnap: 0.1,
                maxBoundsViscosity: 0.9,
                maxZoom: 20,
                minZoom: 2
            }).addLayer(layer)
                .on('zoomend', this.zoomEventHandler)
        }, () => {
            this.displayPorts();
            this.displayPOIs();
            this.setState({ coastlineGeojson: L.geoJSON(geojsonEarthSeas10m) });
        });
    }

    displayPorts() {
        const ports = this.props.ports;
        const AdminMap = this.state.AdminMap;

        if (Object.keys(this.state.portMarkersList).length > 0) {
            for (let portMarker in this.state.portMarkersList) {
                this.state.portMarkersList[portMarker].remove();
            }
        }

        let portMarkers = [];
        if (ports && ports.length > 0) {
            for (let i = 0; i < ports.length; i++) {
                const port = ports[i];

                const latLng = L.latLng(port.lat, port.long);

                let circleColor = '#b4b4b4';
                if (port.zone == 0) {
                    circleColor = '#6ae84e';
                } else if (port.zone == 1) {
                    circleColor = '#4e7fe8ff';
                } else if (port.zone == 2) {
                    circleColor = '#b04ee8ff';
                } else if (port.zone == 3) {
                    circleColor = '#e84e8eff';
                } else if (port.zone == 4) {
                    circleColor = '#e8a04eff';
                } else if (port.zone == 5) {
                    circleColor = '#e5e84eff';
                } else if (port.zone == 6) {
                    circleColor = '#93e84eff';
                } else if (port.zone == 7) {
                    circleColor = '#4ee8c2ff';
                } else if (port.zone == 8) {
                    circleColor = '#4e8ce8ff';
                } else if (port.zone == 9) {
                    circleColor = '#7c4ee8ff';
                } else if (port.zone == 10) {
                    circleColor = '#c94ee8ff';
                } else if (port.zone == 11) {
                    circleColor = '#e84e96ff';
                }

                // add and register a marker
                this.state.portMarkersList[port._id] = L.circle(
                    [port.lat, port.long],
                    {
                        radius: port.radius ? port.radius : 3000,
                        color: circleColor,
                        bubblingMouseEvents: false
                    })
                this.state.portMarkersList[port._id].addTo(AdminMap);
                this.state.portMarkersList[port._id].setLatLng(latLng);
                this.state.portMarkersList[port._id].bindTooltip(port.name);
                this.state.portMarkersList[port._id].portId = port._id;
                this.state.portMarkersList[port._id].on('click', (e) => this.portClickEventHandler(e));
            }
        }
    }

    displayPOIs() {
        const POIs = this.props.POIs;
        const AdminMap = this.state.AdminMap;

        if (Object.keys(this.state.POIMarkersList).length > 0) {
            for (let POIMarker in this.state.POIMarkersList) {
                this.state.POIMarkersList[POIMarker].remove();
            }
        }

        let portMarkers = [];
        if (POIs && POIs.length > 0) {
            for (let i = 0; i < POIs.length; i++) {
                const POI = POIs[i];

                const latLng = L.latLng(POI.lat, POI.long);

                let POI_Icon = L.icon({
                    iconUrl: '../img/poi.svg',
                    iconSize: [25, 25],
                    iconAnchor: [12.5, 12.5]
                })

                // add and register a marker
                this.state.POIMarkersList[POI._id] = L.marker(
                    [POI.lat, POI.long],
                    {
                        bubblingMouseEvents: false,
                        autoPanOnFocus: false,
                        title: POI.name,
                        icon: POI_Icon
                    })
                this.state.POIMarkersList[POI._id].addTo(AdminMap);
                this.state.POIMarkersList[POI._id].setLatLng(latLng);
                this.state.POIMarkersList[POI._id].bindTooltip(POI.name);
                this.state.POIMarkersList[POI._id].POI_ID = POI._id;
                this.state.POIMarkersList[POI._id].on('click', (e) => this.POIClickEventHandler(e));
            }
        }
    }

    changeCustomMarkerPosition(e) {
        this.portClickEventHandler(0)
        this.POIClickEventHandler(0)
        this.setState({ customMarkerPosition: e.latlng, customMarkerOpen: true });
    }

    // Only display coastlines geojson above a certain zoom level
    zoomEventHandler(e) {
        if (this.state.AdminMap.getZoom() > 11) {
            this.state.AdminMap.addLayer(this.state.coastlineGeojson)
        } else {
            this.state.AdminMap.removeLayer(this.state.coastlineGeojson)
        }
    }
    portClickEventHandler(e) {
        if (e === 0) this.props.selectPort(undefined);
        else this.props.selectPort(e.target.portId);
    }
    POIClickEventHandler(e) {
        if (e === 0) this.props.selectPOI(undefined);
        else this.props.selectPOI(e.target.POI_ID);
    }
}


export default AdminMap;
